import { render } from "./ControlDatepicker.vue?vue&type=template&id=1ffb6170&lang=pug"
import script from "./ControlDatepicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlDatepicker.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__